import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4da18554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-testid": "profile-creation-details-headline-block" }
const _hoisted_2 = { class: "custom-font-text" }
const _hoisted_3 = ["data-heap"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_input = _resolveComponent("joy-input")!
  const _component_joy_form_error = _resolveComponent("joy-form-error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.subtitle) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": _ctx.dataHeapTooltipID,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.subtitleHelp), 9, _hoisted_3)
    ]),
    _createVNode(_component_joy_input, {
      id: "headline",
      ref: "headline",
      autocomplete: "off",
      value: _ctx.creationForm.headline,
      "data-testid": "headline-input",
      placeholder: _ctx.$msg('profile.creation.completion.wizard.v2.details.headline.placeholder'),
      onFocus: _ctx.emitFocus,
      onValueChange: _ctx.headlineValueChange,
      onKeypress: _withKeys(_ctx.headlineKeypressEnter, ["enter"])
    }, null, 8, ["value", "placeholder", "onFocus", "onValueChange", "onKeypress"]),
    _withDirectives(_createVNode(_component_joy_form_error, {
      "no-html-error-text": _ctx.$msg('profile.creation.completion.wizard.details.headline.error.length')
    }, null, 8, ["no-html-error-text"]), [
      [_vShow, _ctx.hasError]
    ])
  ]))
}